import { Layout, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import { APP_DOMAIN } from "../../../utls/constants";
import "./index.less";

const GeneralCondtionOfSale = () => {
  const { t } = useTranslation();
  return (
    <Layout className="background-black">
      <Layout.Content className="content GeneralConditionSaleWrapper background-transparent">
        <Row className="relative justify-content-center header-title-container-70">
          <ArrowLeftIconComponent left={-15} top={10} />
          <Typography.Text className="ml-20 mt-10 header-title-black-22">{t("general-conditions-of-sale")}</Typography.Text>
        </Row>
        <Row className="GeneralConditionOfSaleContext">
          <Typography.Paragraph>
            <strong>v12.06.2024 made for ITDW by Versius.</strong>
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz was created and is operated by ITDW SRL a limited liability company whose address is Rue Jean-Joseph Piret 105, 6280 Gerpinnes.
            (hereinafter “the Operator” or “Twizz”).
          </Typography.Paragraph>
          <Typography.Paragraph>To contact us, you can email contact@${APP_DOMAIN} and call at +32474505038.</Typography.Paragraph>
          <Typography.Paragraph>These General Terms and Conditions of Sale govern:</Typography.Paragraph>
          <Typography.Paragraph>
            Any subscription to a Subscription with a Creator on the Platform;
            <br />
            Any media sale.
            <br />
            They supplement the General Conditions of Use governing the use of the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>In this context, it is recalled that Twizz acts as an online platform operator.</Typography.Paragraph>
          <Typography.Paragraph> Article 1. Definitions</Typography.Paragraph>
          <Typography.Paragraph>
            The terms, mentioned below, have in these General Terms and Conditions of Sale, the following meaning. Any missing definition will have
            the meaning given to it in the General Terms and Conditions of Use:
          </Typography.Paragraph>
          <Typography.Paragraph>
            “Subscription”: refers to the right to access the Media granted by the Creator to the User in return for the price of the Subscription ;
            <br />
            “Subscribe to”: refers to the User who has subscribed to a Subscription with a Creator ;<br />
            “Order”: refers to any Subscription, Private Media, Push Media and/or Ticket orders placed by a User with the Creator on the Platform ;
            <br />
            “Account”: refers to the computer interface hosted on the Platform and allowing the User to use the Platform and the Services, while
            benefiting from a space hosting his data ;
            <br />
            “Commission”: refers to the percentage of the Creator’s earnings paid to Twizz in return for its Services. The Commission corresponds to a
            percentage of the Price of any Order made from the Creator;
            <br />
            “General Conditions of Sale” or “GTC”: refers to the contractual conditions of the Platform governing the subscription to a Subscription
            and the sale of Private Media, Push Media and/or Live Access Tickets ;
            <br />
            “General Conditions of Use” or “GCU”: refers to the contractual conditions made available on the home page of the Platform, in order to
            regulate the use of it by any User ;
            <br />
            “General Conditions of Service” or “GTC”: means these General Conditions of Service and all their Annexes, which govern the provision of
            the Services by Twizz to Creators ;
            <br />
            “Content”: means any element published by a User on the Platform, whether it is a Media published by a Creator, or a message or content of
            any kind (text, image, video, sound, multimedia) published by a User ;<br />
            “Creator”: means any natural or legal person registered on the Platform as a creator, sharing the Media through it and having subscribed
            to the General Terms and Conditions of Services ;<br />
            “News feed” or “Feed”: refers to the User’s news feed available on the Platform ;<br />
            “Bank Fees”: means the fees deducted from the sums paid by the User in return for the Payment Services provided to the Creator. Bank Fees
            are equivalent to a percentage of the amounts processed by Payment Services. They are therefore calculated on the amounts actually paid,
            including all taxes, including VAT and all possible costs ;<br />
            “Live”: refers to the functionality allowing the broadcast of a Live Media through the Platform. Access to a Creator’s Live can be free or
            paid ;<br />
            “Media”: means all photographs, videos, music, audio files, podcast, Lives, information, texts, logos, brands, animations, designs and
            models, data and in general all elements and content created by a Creator and published by the latter under his full control and sole
            responsibility on the Platform according to the terms, form and conditions offered to him as part of the Services ;<br />
            “Public Media”: means any Media published by the Creator on the Platform and accessible to any User free of charge;
            <br />
            “Non-Public Media”: means any Media communicated on the Profile, in a blurred way. The Non-Public Media can be a Media viewable against a
            Subscription, a Private Media, a Push Media or a Live ;<br />
            “Private Media” or “Personalized Media”: means any Media exchanged by a Creator and a User, through messaging. Private Media cannot appear
            in the Creator’s profile;
            <br />
            “Media Push”: refers to any Media spontaneously proposed by a Creator to one or more Users, through private messaging ;<br />
            “Twizz” or “the Operator”: Indiscriminately refers to the Operator or the Platform herein;
            <br />
            “Parties”: in the plural, designates Twizz and the User together. In the singular, designates only one of the two Parties;
            <br />
            “Platform”: refers to the Online Platform accessible at the following address: https://${APP_DOMAIN}/ or through the corresponding mobile
            applications. The Platform includes all the web pages, Services and functionalities offered to Users;
            <br />
            “A tip”: means the amount freely paid by the User to the Creator at his sole discretion, without direct consideration;
            <br />
            “Payment Service Provider” or “PSP”: means the company, holder of a bank authorization, providing, through the Operator, payment services
            to Creators in order to enable them to collect Users’ payments;
            <br />
            “Price”: means the amount of money or crypto assets paid by a User to the Creator through the Platform in return for a Subscription, Media
            or Live ticket. Prices may also include Tips;
            <br />
            “Profile”: refers to the Creator’s presentation page, in which both the latter’s activity and the Media and Subscriptions he offers are
            presented;
            <br />
            “Services”: refers to all the Services offered by Twizz to Users through the Platform;
            <br />
            “Support Site”: means the website hosted at https://support.${APP_DOMAIN}/, edited by the Operator in order to provide maximum information
            and assist any User in his use of the Platform and its Services;
            <br />
            “Specifies”: refers to the characteristics of a Private Media, proposed by a Creator or required by a User when making the request. Any
            Content ordered on the Platform must comply with the Specifications agreed between the User and the Creator;
            <br />
            “Story”: refers to the Media published by the Creator to illustrate its topicality, which will automatically disappear after a period of
            seventy-two (72) hours;
            <br />
            “SuperStar”: means any Creator who meets the criteria defined on the Support Site (https://support.${APP_DOMAIN}/) and as such benefits
            from differentiated treatment;
            <br />
            “Ticket”: means the ticket purchased by a User and allowing him to attend a paid Live;
            <br />
            “User”: means any person who accesses and navigates the Platform, whether he is a User, Creator, Ambassador or a simple Internet user;
          </Typography.Paragraph>
          <Typography.Paragraph>Article 2. Object</Typography.Paragraph>
          <Typography.Paragraph>These General Terms and Conditions of Sale govern any Order placed on the Platform.</Typography.Paragraph>
          <Typography.Paragraph>These GTC supplement the T&amp;Cs of the Platform.</Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a contradiction between the GTC and the T&amp;Cs, the GTC will apply as a priority.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 3. Acceptance of the General Terms and Conditions of Sale</Typography.Paragraph>
          <Typography.Paragraph>To be able to conclude these GTC, the User must necessarily:</Typography.Paragraph>
          <Typography.Paragraph>
            – Be a duly registered legal person acting through a legal representative or a person duly authorized to bind him legally;
            <br />– Or be a natural person of full age, capable, who is not placed under any measure of legal protection (curatelle, guardianship).
            The GTC may be resolved in the event that one of these conditions is no longer met.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User undertakes to read these General Terms and Conditions of Sale carefully and to expressly accept them, before paying for an Order
            with a Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            These General Terms and Conditions are referenced at the bottom of each page of the Platform and must be consulted before placing the
            Order. The User is invited to carefully read, download, print the General Terms and Conditions of Sale and keep a copy.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz advises the User to read the General Terms and Conditions of Sale for each new Order, the latest version of the said Conditions
            applying to any new Order.
          </Typography.Paragraph>
          <Typography.Paragraph>
            As part of the Order procedure, the User acknowledges having read, understood and accepted the General Terms and Conditions of Sale
            without limitation or condition. In the same way, he acknowledges that he wishes to have immediate access to the Content and thus
            expressly waive his right of withdrawal.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 4. Media Characteristics</Typography.Paragraph>
          <Typography.Paragraph>
            The User acknowledges that the Media are broadcast or published on the Platform under the responsibility of the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator guarantees that he has received the consent of any person appearing on the Media to:
          </Typography.Paragraph>
          <Typography.Paragraph>
            Appear on the Media which are, in essence, potentially published to a wide audience ;<br />
            Communicate and/or market the Media to Users and/or Users ;<br />
            Publish the Media on the Platform.
            <br />
            The Creator guarantees that he verifies the age of each person appearing on the Media and in particular that each of them is of legal age,
            which the Creator must be able to demonstrate at Twizz’s first request.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator gives no guarantee as to the frequency of publication of Media, their unpublished nature, or as to the number of them, which
            the User expressly accepts and acknowledges.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User acknowledges that he will not be able to access Non-Public, Private and Paid Push Media until he has subscribed to a Subscription
            and made their purchase.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 5. Subscription to a Subscription</Typography.Paragraph>
          <Typography.Paragraph>To be able to subscribe to a Subscription, the User must have the legal capacity.</Typography.Paragraph>
          <Typography.Paragraph>
            To subscribe to a Subscription, the User must be registered on the Platform and log in to his Account.
          </Typography.Paragraph>
          <Typography.Paragraph>5.1. Essential characteristics of the Subscription</Typography.Paragraph>
          <Typography.Paragraph>
            Will be presented on the Creator’s Profile the essential characteristics of the Subscription he offers as well as the mandatory
            information under applicable law and to verify its accuracy.
          </Typography.Paragraph>
          <Typography.Paragraph>These characteristics appear on the Creator’s Public Profile and include:</Typography.Paragraph>
          <Typography.Paragraph>
            The Creator’s description ;<br />
            The rights conferred by the Subscription ;<br />
            The frequency of renewal of the Subscription (monthly, semi-annual) ;<br />
            The price of the Subscription.
            <br />
            The User undertakes to read this information carefully before subscribing to a Subscription on the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>The User is informed that the Subscription includes in particular:</Typography.Paragraph>
          <Typography.Paragraph>
            The right to consult Non-Public Media ;<br />
            The right to request Private Media from the Creator;
            <br />
            The right to buy Push Media ;<br />
            The right to receive an Invitation to Live ;<br />
            The right to buy a Ticket to attend the Lives ;<br />
            Each Subscription is only valid for the Creator with whom the User has subscribed to this Subscription.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is specified that the Subscription subscribed to with a Creator does not give the User any right as to the quantity and quality,
            necessarily subjective, of the Media published by the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In any case, it is up to each User to carry out research on each Creator, relating in particular to their activity on the Website, before
            subscribing to any Subscription.
          </Typography.Paragraph>
          <Typography.Paragraph>4.2. Subscription procedure</Typography.Paragraph>
          <Typography.Paragraph>4.2.1. Subscription to the Subscription</Typography.Paragraph>
          <Typography.Paragraph>Subscription to the Subscription is made through the Platform</Typography.Paragraph>
          <Typography.Paragraph>To subscribe to a Subscription, the User is invited to follow the steps below.</Typography.Paragraph>
          <Typography.Paragraph>
            The User can subscribe to a Subscription with the Creator on the Platform by clicking on the “Subscribe” button available on the Creator’s
            Profile.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is then returned to a page describing the essential characteristics of the Subscription (conferred rights, price, duration…).
          </Typography.Paragraph>
          <Typography.Paragraph>The User will be invited to:</Typography.Paragraph>
          <Typography.Paragraph>
            Choose the desired Subscription offer;
            <br />
            Select the Subscription to which he wishes to subscribe;
            <br />
            If necessary, enter your Promo Code;
            <br />
            Choose your payment method ;<br />
            Accept these GTC ;<br />
            Pay the Subscription Price by following the instructions on the Platform.
            <br />
            4.2.2. Acknowledgement of receipt
          </Typography.Paragraph>
          <Typography.Paragraph>
            Once all the steps described above are completed, a page appears on the Platform to acknowledge receipt of the User’s Order.
          </Typography.Paragraph>
          <Typography.Paragraph>
            A copy of the acknowledgement of receipt of the Order is automatically sent to the User by email, provided that the email address provided
            through the registration form is correct.
          </Typography.Paragraph>
          <Typography.Paragraph>4.2.3. Subscription price</Typography.Paragraph>
          <Typography.Paragraph>
            The User acknowledges that the price of the Subscription is due when subscribing to the Subscription as well as each renewal of the said
            Subscription.
          </Typography.Paragraph>
          <Typography.Paragraph>4.2.4. Duration of the Subscription</Typography.Paragraph>
          <Typography.Paragraph>The Subscription to the Creator’s account can be offered through two alternative offers:</Typography.Paragraph>
          <Typography.Paragraph>
            A “monthly” offer corresponding to an indefinite Subscription, giving rise to automatic monthly payments;
            <br />
            An “X months” offer corresponding to a Subscription for a fixed period, giving rise to a one-time payment.
            <br />
            By default, the Subscription is offered via the monthly offer and for an indefinite period. The User is therefore debited monthly, on the
            anniversary date.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If the Subscription is subscribed for an indefinite period, it may then be terminated at any time, before the end of the current month, it
            being understood that any month of subscription started will be due in full. No pro rata temporis refund can be requested.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that the Subscriber has opted for the “X months” Offer corresponding to a fixed period, the price requested is flat-rate and
            paid in advance. Thus, any early termination of the Fixed-term Subscription will not give rise to any refund.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any Subscription for a fixed period is, upon expiration, automatically renewed in the form of an indeterminate Subscription, giving rise
            to an automatic monthly payment, on the anniversary date. The price applied will then be the one provided for the “X months” Offer.
          </Typography.Paragraph>
          <Typography.Paragraph>4.2.5. Termination of the Subscription</Typography.Paragraph>
          <Typography.Paragraph>
            The User may terminate his Subscription for an indefinite period at any time, for any reason, and in particular in the event of no
            activity on the part of a Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            To do this, the User must go to his Account, in the tab dedicated to his Subscriptions and choose the one he wishes to report at the end
            of the current month.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that the User cancels his Subscription after the possible renewal date, the Subscription will end at the end of the
            commitment period and/or on the date of the next renewal and the User may continue to benefit from the benefits conferred by the
            Subscription until that date.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 5. Request for Private Media</Typography.Paragraph>
          <Typography.Paragraph>To request a Private media, the User must: </Typography.Paragraph>
          <Typography.Paragraph>
            Be registered on the Platform;
            <br />
            Be a subscriber to the Creator concerned by the request.
            <br />
            5.1. Private Media application procedure
          </Typography.Paragraph>
          <Typography.Paragraph>5.1.1. Private Media Request</Typography.Paragraph>
          <Typography.Paragraph>
            The User will have the opportunity to request Private Media from the Creator with whom he has subscribed a Subscription via the Platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User acknowledges that a Private Media is not necessarily a Media exclusively intended for the User but a Media that corresponds to
            the User’s request and that is not accessible free of charge on any other medium or platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator may therefore reuse any Private Media communicated to the User, provided, however, that it is not made available free of
            charge, on any medium for a minimum period of two years from its publication on Twizz. [b]
          </Typography.Paragraph>
          <Typography.Paragraph>To request a Private Media, the User must :</Typography.Paragraph>
          <Typography.Paragraph>
            Use the Platform’s Messaging ;<br />
            Communicate to the Creator the Specifications of the Private Media he wishes to request, namely the format (photo, video…) or any other
            aspect of the Media (content, object, aesthetics…).
            <br />
            The Creator may also, on his own initiative, offer the User to view a Media by means of Messaging, in the form of a Media Push.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In this case, the Creator undertakes to provide the User with the essential characteristics of the Private Media, in particular with
            regard to its format (photo, video) and its content (content, duration, etc.). The Creator also undertakes to provide him with the
            mandatory information under applicable law and to verify its accuracy
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is informed that he may, at his sole discretion and under his sole responsibility, accept or refuse the Creator’s proposal.
          </Typography.Paragraph>
          <Typography.Paragraph>5.1.3. General provisions</Typography.Paragraph>
          <Typography.Paragraph>The User is informed that the Creator:</Typography.Paragraph>
          <Typography.Paragraph>
            Has no obligation to respond to his request;
            <br />
            May refuse all or part of his request at his sole discretion.
            <br />
            The User will be alerted of the Creator’s response by email to the email address provided as part of his registration and on the Platform
            by means of a notification.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that the Creator responds favorably to the User’s request, he will offer a price to the User under his sole responsibility
            and full control.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that the User accepts the Creator’s proposal, he will then be invited to pay the agreed price.
          </Typography.Paragraph>
          <Typography.Paragraph>5.2. Provision of Private Media or Viewing of Private Media</Typography.Paragraph>
          <Typography.Paragraph>
            The Creator will have a period of seventy-two (72) hours from payment to make the Private Media available to the User through Messaging,
            in accordance with the User’s Specifications.
          </Typography.Paragraph>
          <Typography.Paragraph>5.3. Private Media Refund</Typography.Paragraph>
          <Typography.Paragraph>The User may request a refund from the Private Media:</Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a lack of communication of the Private Media by the Creator within the prescribed time limits. In this case, the User must
            send his refund request within fourteen (14) days from the expected maximum delivery date;
            <br />
            In the event of non-compliance of the Media with the Specifications agreed between the Creator and the User. In this case, the User must
            send his refund request within fourteen (14) days from the date of delivery of the Media.
            <br />
            May constitute a non-compliance of the Private Media with the User’s Specifications, a relative lack of conformity:
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the Media format;
            <br />
            Has its content.
            <br />
            In the event of the User’s formulation of a dispute relating to an alleged inadequacy of the Private Media with its Specifications, he
            must precisely indicate the lack of conformity.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz will be the sole arbiter of the Private Media’s compliance with the Specifications, its decision being imposed on the Creator and
            the User.
          </Typography.Paragraph>
          <Typography.Paragraph>
            After prior exchanges between the Creator and the User concerned, the refund request can be made directly to Twizz by email at support@$
            {APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If the request is considered well-founded, Twizz may proceed, on behalf of the Creator, to refund all the sums paid by the User under the
            Private Media.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 6. Purchase of Media Push</Typography.Paragraph>
          <Typography.Paragraph>The Creator can offer Users to purchase Push Media.</Typography.Paragraph>
          <Typography.Paragraph>To purchase a Push Media on the Platform, the User must:</Typography.Paragraph>
          <Typography.Paragraph>Be registered on the platform;</Typography.Paragraph>
          <Typography.Paragraph>Log in to your Account;</Typography.Paragraph>
          <Typography.Paragraph>If the Media Push is paid, have subscribed to a Subscription with the Creator concerned;</Typography.Paragraph>
          <Typography.Paragraph>Pay the payment of the price corresponding to the Media Push.</Typography.Paragraph>
          <Typography.Paragraph>
            The purchase of a Media Push allows unique access to this Media, without any other form of subscription to other content.
          </Typography.Paragraph>
          <Typography.Paragraph>
            It is specified that the Push Media appears blurred until it is purchased by the User. Thus, the User expressly acknowledges that he will
            only be able to access the Media push after making his purchase.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 7. Purchase of Ticket</Typography.Paragraph>
          <Typography.Paragraph>7.1. Ordering a Ticket</Typography.Paragraph>
          <Typography.Paragraph>To participate in a paid Live, the User will have to purchase a Ticket.</Typography.Paragraph>
          <Typography.Paragraph>To purchase a Push Media on the Platform, the User must:</Typography.Paragraph>
          <Typography.Paragraph>
            Be registered on the platform;
            <br />
            Log in to your Account;
            <br />
            Have subscribed to a Subscription with the Creator concerned or have received an invitation from the Creator concerned;
            <br />
            Pay the payment of the Ticket price.
            <br />A Ticket can only be refunded in the following cases:
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Live is finally cancelled or cannot take place;
            <br />
            The Live lasts less than five (5) minutes.
            <br />
            Any purchase of a Ticket offers the right to watch the replay of the Live, at any time.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 8. Tips</Typography.Paragraph>
          <Typography.Paragraph>
            <br />
            Any User may pay Tips to the Creator. It is understood that the payment of Tips is made without consideration and constitutes a simple
            donation for the benefit of the Creator to support his work.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 9. Acknowledgement of receipt of Orders</Typography.Paragraph>
          <Typography.Paragraph>
            Once the User has made his Order, a page appears on the Platform to acknowledge receipt of the User’s Order.
          </Typography.Paragraph>
          <Typography.Paragraph>
            A copy of the acknowledgement of receipt of the Order is automatically sent to the User by email, provided that the email address provided
            through the registration form is correct.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 10. Payment and invoicing of Orders</Typography.Paragraph>
          <Typography.Paragraph>10.1 Payment of Orders</Typography.Paragraph>
          <Typography.Paragraph>10.1.1. Price</Typography.Paragraph>
          <Typography.Paragraph>
            The User will find on the payment page of the Platform the prices displayed in euros All Taxes Included (VAT).
          </Typography.Paragraph>
          <Typography.Paragraph>
            Prices including VAT include in particular, where applicable, Value Added Tax (VAT) at the rate in force on the date of the Order as well
            as the Bank Fees incurred by the Creator. Any change in the applicable rate may impact the price of the Subscription from the date of
            entry into force of the new rate.
          </Typography.Paragraph>
          <Typography.Paragraph>The applicable VAT rate is expressed as a percentage of the price proposed by the Creator.</Typography.Paragraph>
          <Typography.Paragraph>
            The prices indicated are valid, unless there is a gross mistake. The applicable price is that indicated on the payment page of the
            Platform on the date on which the price is paid by the User.
          </Typography.Paragraph>
          <Typography.Paragraph>10.1.2. Means of payment</Typography.Paragraph>
          <Typography.Paragraph>
            All payments, whether in fiat money or cryptocurrencies, are managed through Payment Service Providers legally authorized to provide
            payment services to Users.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User can thus pay for his Online Orders on the Platform according to the means offered by the Platform, i.e. by:
          </Typography.Paragraph>
          <Typography.Paragraph>
            Credit card (Visa, CB, Mastercard);
            <br />
            Paypal, for some Creators ;<br />
            Cryptocurrency.
            <br />
            If necessary, the User undertakes to accept and comply with the general conditions of the PSPs, applicable to the use of their services.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User guarantees the Creator that he has all the authorizations required to use the chosen means of payment.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User will take all necessary measures to guarantee the security and confidentiality of the data transmitted online as part of the
            online payment on the Site.
          </Typography.Paragraph>
          <Typography.Paragraph>
            As such, it is specified that all payment information provided on the Platform is transmitted to the Payment Service Provider and is not
            processed by the Operator.
          </Typography.Paragraph>
          <Typography.Paragraph>10.1.3. Date of payment</Typography.Paragraph>
          <Typography.Paragraph>
            Subject to the nature of his bank account and the agreements with his bank, the User’s account will be debited as soon as the Order placed
            on the Site. In the event of a Subscription, the User’s bank account will also be debited each time the Subscription is renewed.
          </Typography.Paragraph>
          <Typography.Paragraph>10.1.4. Refusal of payment</Typography.Paragraph>
          <Typography.Paragraph>
            If the bank refuses to debit a card or other means of payment, the User must contact the Platform’s Customer Service in order to pay for
            the Order by any other payment method valid and accepted by the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event that, for any reason whatsoever, opposition, refusal or other, the transmission of the flow of money due by the User proves
            impossible, the Order will be cancelled and the sale or subscription automatically terminated.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 11. Right of withdrawal</Typography.Paragraph>
          <Typography.Paragraph>
            By accessing the Subscription, the Media or the Live following any Order made from the Platform, in accordance with Articles L. 221-18 et
            seq. of the Consumer Code, the User acknowledges that the Creator has fully fulfilled his obligations, that he wishes to have immediate
            access to the content and that he waives the benefit of the fourteen (14) day withdrawal period resulting from the above provisions of the
            Consumer Code.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Indeed, no Order (neither the Subscription, nor the Media, nor the Lives) can in principle give rise to a right of withdrawal, in
            accordance with Article L221-28 of the Consumer Code which provides that “The right of withdrawal cannot be exercised for contracts:
          </Typography.Paragraph>
          <Typography.Paragraph>3° Supply of goods made according to the consumer’s specifications or clearly personalized;</Typography.Paragraph>
          <Typography.Paragraph>
            13° The provision of digital content not provided on a physical medium whose execution has begun after the consumer’s express prior
            agreement and express renunciation of his right of withdrawal.”.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 12. Intellectual Property</Typography.Paragraph>
          <Typography.Paragraph>
            In accordance with the General Terms and Conditions of Use (GCU), the Media published by the Creator are the exclusive property of the
            Creator, which the User expressly accepts and acknowledges.
          </Typography.Paragraph>
          <Typography.Paragraph>
            By subscribing to the Subscription or purchasing the right of access to a Media, the User is simply granted the right to view the said
            Media. Subject to the exceptions provided for in the Intellectual Property Code, the User is therefore not assigned any intellectual
            property rights outside the right of viewing, which therefore expressly excludes any right of representation, reproduction, marketing or
            adaptation.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Any representation or reproduction, total or partial, of the Media by any process whatsoever, without the prior authorization of the
            Creator, is prohibited and will constitute an infringement punishable by the provisions of the Intellectual Property Code, in accordance
            with the General Conditions of Use.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Regarding Private Media, the Creator grants the User by having placed the Order a personal license to view, reproduce and represent in a
            private and/or family circle only. This license is granted worldwide and for the duration of the intellectual property rights.
          </Typography.Paragraph>
          <Typography.Paragraph>Consequently, the User undertakes to:</Typography.Paragraph>
          <Typography.Paragraph>
            Use the Media published by the Creator only for his personal needs for the purpose of consulting the Media on the Platform, excluding any
            use of the Media for commercial or professional purposes ;<br />
            Do not publish, disseminate or communicate all or part of the Media published by a Creator to third parties, by any means whatsoever, on
            any medium whatsoever, in particular on social networks, whether free of charge or for consideration ;<br />
            Do not modify, adapt or violate the integrity of all or part of the Media published by a Creator in any way.
            <br />
            Any download, sharing, making available, reproduction, or any other form of reproduction, use or dissemination excluding consultation on
            the Platform infringes the rights of the Creator, Twizz and engages the responsibility of the User.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a serious suspicion of breach of these obligations, Twizz may delete the User’s Account at its exclusive fault, without
            any refund for the sums paid by the User being payable by the latter.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a proven breach of these commitments, which are part of the essential commitments of the Parties, the User undertakes to
            pay a sum equal to 500 euros including VAT or 10 times the amount paid by the latter in respect of the Subscription or Media concerned by
            the infringement, the most important amount being then retained. The amount of this penalty will then be returned to the Creator.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The payment of this penalty is non-discharging and does not exclude the User’s liability for the violation of the Creator’s rights, who
            will in any case retain the right to claim compensation for his entire damage resulting therefrom.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Finally, the User is informed that Twizz is mandated by the Creator to request the deletion of Media that have been republished in whole
            or in part by the User on the Platform or on any other platform, social network or medium of any kind.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 13. Guarantee and liability</Typography.Paragraph>
          <Typography.Paragraph>The Media are published by the Creator under his responsibility.</Typography.Paragraph>
          <Typography.Paragraph>
            Users benefit from legal guarantees as defined by Articles L.224-25-12 et seq. of the Consumer Code provided that the Creator is qualified
            as a professional.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The content and conditions for the implementation of the legal guarantee of conformity are specified in the Annex hereto.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator declares that he owns all the intellectual property rights in the Content sold via these GTC.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator declares that such Content does not in any way infringe the rights of third parties, in particular that it does not constitute
            an infringement or an act of unfair or parasitic competition of a pre-existing work and that it does not in any way infringe the image or
            intellectual property rights of third parties.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of a dispute or complaint related to an Order, the User is invited to consult the T&amp;Cs to find out the procedure to be
            followed and, if necessary, to contact the Operator at support@${APP_DOMAIN}.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If the Creator’s Account to which he is subscribed is terminated or closed for any reason, then the Subscriber may request the refund of
            his Subscription pro rata temporis.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 14. Validity of the General Conditions</Typography.Paragraph>
          <Typography.Paragraph>
            Any change in the legislation or regulations in force, or any decision of a competent court invalidating one or more clauses of these GTC
            shall not affect the validity of these GTC. Such a modification or decision does not in any way authorize Customers to disregard these
            GTC.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 15. Modification of the General Conditions</Typography.Paragraph>
          <Typography.Paragraph>
            These General Terms and Conditions of Sale apply to all Orders placed online on the Platform, as long as the Platform is available online.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The General Terms and Conditions are precisely dated and may be modified and updated by Twizz at any time. The applicable General
            Conditions are those in force at the time of the Order. Changes to the General Conditions will not apply to Orders already placed.
          </Typography.Paragraph>
          <Typography.Paragraph>Article 17. Applicable law and competent jurisdiction</Typography.Paragraph>
          <Typography.Paragraph>THESE GENERAL CONDITIONS AND THE RELATIONS BETWEEN THE USER Twizz ARE GOVERNED BY BELGIAN LAW.</Typography.Paragraph>
          <Typography.Paragraph>IN THE EVENT OF A DISPUTE, ONLY THE BELGIAN COURTS WILL HAVE JURISDICTION.</Typography.Paragraph>
          <Typography.Paragraph>
            However, prior to any recourse to the arbitral or state judge, the User is invited to respect the dispute management procedure specified
            in the T&amp;Cs.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If no agreement is reached or if the User justifies having tried, beforehand, to resolve his dispute directly with the Creator by a
            written complaint, an optional mediation procedure will then be proposed, conducted in a spirit of loyalty and good faith with a view to
            reaching an amicable agreement upon the occurrence of any conflict relating to these GTC, including its validity.
          </Typography.Paragraph>
          <Typography.Paragraph>To initiate this mediation, the User can contact Twizz.</Typography.Paragraph>
          <Typography.Paragraph>
            The Party wishing to implement the mediation process must first inform the other party by registered letter with acknowledgment of receipt
            indicating the elements of the conflict.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Parties undertake to make their best efforts to resolve amicably and in good faith the disputes between them.
          </Typography.Paragraph>
          <Typography.Paragraph>As mediation is not mandatory, the User or Creator may withdraw from the process at any time.</Typography.Paragraph>
          <Typography.Paragraph>
            IN THE HYPOTHESIS OR MEDIATION WOULD FAIL OR WOULD NOT BE ENVISAGED, THE DISPUTE THAT MAY HAVE GIVEN RISE TO MEDIATION WILL BE ENTRUSTED
            TO THE COMPETENT COURT DESIGNATED ABOVE.
          </Typography.Paragraph>
          <Typography.Paragraph>Annex 1 – Legal guarantee of conformity</Typography.Paragraph>
          <Typography.Paragraph>
            The User benefits from legal guarantees as defined by Articles L.224-25-12 et seq. of the Consumer Code and detailed below.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is informed of the application of Article L.224-25-12 of the Consumer Code, which provides for the delivery of goods in
            accordance with the contract as well as the criteria set out in Article L. 224-14. the User may report any lack of conformity existing at
            the time of the supply of the Content within the meaning of Article L.225-25-10 of the Consumer Code, which appear (during the period of
            supply of the Content as provided for in the General Conditions of Use.
          </Typography.Paragraph>
          <Typography.Paragraph>
            This warranty also applies to lack of conformity resulting from the incorrect integration of the Content into the User’s digital
            environment :
          </Typography.Paragraph>
          <Typography.Paragraph>– When it was made by the Creator or under his responsibility; or</Typography.Paragraph>
          <Typography.Paragraph>
            – When it has been carried out by the User, provided that it results from shortcomings in the Creator’s instructions.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In this regard, pursuant to Articles L.224-25-13 and L.224-25-14 of the Consumer Code, the Content is compliant provided that:
          </Typography.Paragraph>
          <Typography.Paragraph>
            1° It corresponds to its description, type, quantity and quality, […] concerning any characteristic provided for in the Contract (Article
            5) or that the User may legitimately expect for Content of the same type, having regard to the nature of this Content as well as the
            public statements made by the Creator or any person upstream in the chain of transactions, including in advertising or labelling;
          </Typography.Paragraph>
          <Typography.Paragraph>
            2° It is suitable for any special use sought by the User, brought to the attention of the Creator at the latest at the time of the
            conclusion of the CONTRACT and accepted by the latter;
          </Typography.Paragraph>
          <Typography.Paragraph>
            3° It is issued with all the accessories […] to be provided in accordance with the Contract or which the User can legitimately expect;
          </Typography.Paragraph>
          <Typography.Paragraph>4° It is updated in accordance with the Contract and what the User can legitimately expect;</Typography.Paragraph>
          <Typography.Paragraph>5° It is suitable for the usually expected use of Content of the same type […];</Typography.Paragraph>
          <Typography.Paragraph>
            6° He has the qualities that the Creator presented to the User in the form of a trial version or preview before the conclusion of the
            Contract;
          </Typography.Paragraph>
          <Typography.Paragraph>
            7° It is provided according to the most recent version available at the time of the conclusion of the Contract, unless otherwise agreed by
            the Parties;
          </Typography.Paragraph>
          <Typography.Paragraph>8° It is provided without interruption throughout this period.</Typography.Paragraph>
          <Typography.Paragraph>
            However, the Creator or, where applicable, Twizz, is not bound by any public statements mentioned in 1° above if he demonstrates: (a) that
            he did not know them and was legitimately unable to know them; (b) that at the time of the conclusion of the contract, the public
            statements had been rectified under conditions comparable to the initial declarations; or (c) that the public statements could not have
            had any influence on the purchase decision.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User cannot contest conformity by invoking a defect concerning one or more particular characteristics of the Content of which he has
            been specifically informed that they deviate from the conformity criteria, a deviation to which he expressly and separately consented at
            the conclusion of the Contract. As such, the Content may in particular experience interruptions during the period of delivery of the
            Content in accordance with the General Terms and Conditions of Use.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Throughout the contractual period of provision of the Content, proof of the conformity of the Content is the responsibility of the Creator
            or, if applicable, Twizz.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator or Twizz, is not responsible for any lack of conformity directly attributable to the incompatibility between the Content and
            the User’s digital environment and that the User had been previously informed by the Creator or Twizz of the technical compatibility
            requirements. As such, the User must cooperate with the Creator or Twizz, to the extent reasonably possible, to establish whether or not
            the lack of conformity is caused by the incompatibility in question. In the absence of cooperation, the User will bear the burden of
            demonstrating the non-conformity of the Content.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of lack of conformity, the User has the right to compliance of the Content or, failing that, to the reduction of the price or
            the resolution of the price in accordance with Articles L. 224-25-17 et seq. of the Consumer Code. the User also has the right to suspend
            payment until compliance by the Creator (or Twizz) of his warranty obligations under the conditions of Articles 1219 and 1220 of the Civil
            Code.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Compliance takes place free of charge, without undue delay following the Customer’s request and without major inconvenience for him, given
            the nature and intended use of the Content. He is not required to pay for the use of the Content during the contractual period during
            which the Content was not compliant.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator or Twizz may refuse compliance if it is impossible or results in disproportionate costs in particular with regard to:
          </Typography.Paragraph>
          <Typography.Paragraph>– the value that the Content would have in the absence of a lack of conformity;</Typography.Paragraph>
          <Typography.Paragraph>– the importance of the lack of conformity.</Typography.Paragraph>
          <Typography.Paragraph>
            This refusal is the subject of a reasoned decision in writing or on any durable medium addressed to the User. When these conditions are
            not respected, the User may, after formal notice, continue the forced execution in kind of the compliance.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User has the right to a reduction in the price or to the termination of the Contract (unless the lack of conformity is minor) in the
            cases and according to the procedures provided for in Article L.224-25-20 of the Consumer Code, i.e., in particular, in the event of
            refusal of compliance or failure by the Creator to comply, in accordance with the above-mentioned article.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User is not required to request prior compliance when the lack of conformity is so serious that it justifies that the price reduction
            or the termination of the Contract is immediate.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The User informs the Creator or Twizz of his decision to obtain a price reduction or the termination of the Contract.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The price reduction is proportional to the difference between the value of the Content provided and the value of the Content without
            defects.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Twizz reimburses the User and returns to him any other benefit received under the Contract as soon as possible and at the latest within
            fourteen (14) days of the notification of the decision to terminate the Contract or obtain the price reduction. Unless expressly agreed by
            the Customer and at no additional cost, the refund will take place according to the same means of payment as that used for the purchase.
          </Typography.Paragraph>
          <Typography.Paragraph>
            In the event of termination of the Contract, the User refrains from using the Content or making it accessible to third parties.
          </Typography.Paragraph>
          <Typography.Paragraph>
            The Creator returns to the User, free of charge and within a reasonable time, in a commonly used and machine-readable format, any content
            provided or created by the User during his use of the Content (other than personal data), unless it:
          </Typography.Paragraph>
          <Typography.Paragraph>1° is of no use outside the context of use of the Content;</Typography.Paragraph>
          <Typography.Paragraph>2° relates only to the Customer’s activity when he uses the Content; or</Typography.Paragraph>
          <Typography.Paragraph>
            3° if this content has been aggregated by the Creator with other data and can only be disaggregated or can only be aggregated with
            disproportionate efforts.
          </Typography.Paragraph>
          <Typography.Paragraph>The Creator undertakes not to use the content provided or created by the User</Typography.Paragraph>
          <Typography.Paragraph>
            (Other than personal data) only if it has been generated jointly with other customers and if other customers can continue to use it. The
            provisions of this article are without prejudice to the award of damages.
          </Typography.Paragraph>
          <Typography.Paragraph></Typography.Paragraph>
        </Row>
      </Layout.Content>
    </Layout>
  );
};

export default GeneralCondtionOfSale;
